import { render, staticRenderFns } from "./grouporder.vue?vue&type=template&id=d63e91ce&"
import script from "./grouporder.vue?vue&type=script&lang=js&"
export * from "./grouporder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports